<template>
	<div v-show="bodyIsShow">
		<input type="hidden" id="abTestFlag" :value="abTestFlag">
		<section v-if="(periods.successBannerList.length>0) && (periods.successBannerCb==true)">
     		<mt-swipe :auto="4000">
			  <mt-swipe-item v-for="(item,index) in periods.successBannerList">
			  	<a v-if="item.text" :href="item.text">
			  		<img style="width:100%;height: 100%;" :class="['swiper-img',{'trackEvent':(periods.cityId == 170 && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+'/'+periods.picUrl+item.imageName">
			  	</a>
			  	<img v-else style="width:100%;" :class="['swiper-img',{'trackEvent':(periods.cityId == 170 && index==0)}]" data-track="carfestivalDetail-10-linkToAd-detail" :src="commmonWebConfig.picHost+'/'+periods.picUrl+item.imageName">
			  </mt-swipe-item>
			</mt-swipe>
		</section>
		<section>
			<div class="perfectwrap">
				<!--<div class="tit">完善更多信息，享更贴心服务 </div>-->
					<!--
						///////////////////////////////如果有完善信息页引导文案，则显示引导文案////////////////////////
						-->
					
						<div v-if="periods.improveInfoTextFlag==1" class="addtext">{{periods.improveInfoText}}</div>
					<!--
						///////////////////////////////如果有完善信息页引导图片，则显示引导图片////////////////////////
					-->
						<div v-if="periods.improveInfoPicFlag==1" class="addimgwrap">
							<img :src="periods.improveInfoPic" alt="" />
						</div>

				<div>
					<div v-if="(isTicket == 1 ||  isTicket == 2) && address == 1" class="sinform addresscommon">
						<em class="signUpfrom-icon signUpfrom-icon02"></em>
						<input type="text" class="sinform-text" name="address" placeholder="请输入门票收件地址"  id="address">
					</div>
					<div v-if="car && car == 0" class="sinform">
						<em class="icon-arror-l"></em>
						<div id="insertCarper" @click="getData($event)" class="sinform-text">请选择意向品牌或车型</div>
						<div class="icon-arror-r"></div>
					</div>
				</div>

				<div class="seleoverall">
					<div class="selectwrap">
						<span class="shopcartype">购车方式</span>
					</div>
					<div class="caritem clearfix" id="index-cartype">
						<ul v-if="buyList.length>0" >
							<li  v-for="(item,index) in buyList" :data-buyType="item.value">{{item.name}}</li>
							
						</ul>
					</div>
				</div>
				<div v-if="instalments==1" class="seleoverall">
					<div class="selectwrap">
						<span class="shopcartype">是否分期</span>
					</div>
					<div class="caritem clearfix" id="index-bystages">
						<ul>
							<li data-splitMoney="0">全款</li>
							<li data-splitMoney="1">分期</li>
						</ul>
					</div>
				</div>
				<div id="submitBtn" @click="submit()" class="submit1">
					提交
				</div>
			</div>	
		</section>
		<section>
			<div class="whyselect clearfix">
				<div class="line1"></div>车展亮点<div class="line2"></div>
     			<div class="pldge-wrap clearfix">
					<div class="promise1 promise  bigline btnline">
						<em class="icon01"></em>
						<div class="rightbox">
							<div class="title">车型丰富</div>
							<div class="center">多款车型任您选看车</div>
							<div class="size-btn">选车比价一站完成</div>
						</div>
					</div>
					<div class="promise2 promise btnline">
						<em class="icon02"></em>
						<div class="rightbox">
							<div class="title">覆盖全面</div>
							<div class="center">全国30个服务网点</div>
							<div class="size-btn">覆盖50个品牌</div>
						</div>
					</div>
					<div class="promise3 promise bigline">
						<em class="icon03"></em>
						<div class="rightbox">
							<div class="title">车源优质</div>
							<div class="center">正规厂家4s店合作</div>
							<div class="size-btn">提供优质车源</div>
						</div>
					</div>
					<div class="promise4 promise">
						<em class="icon04"></em>
						<div class="rightbox">
							<div class="title">价格保障</div>
							<div class="center">全国范围询价</div>
							<div class="size-btn">确保低价</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- 侧拉品牌 -->
		<div class="sider-mark" id="sider-mark"></div>
		<div class="sider-wrap" id="sider-wrap">
			<div id="side-brand" class="side-div side-brand">
			</div>
			<div id="side-carstyle" class="side-div side-carstyle">
			</div>
		</div>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.mint-swipe{
		height:5.33333rem;
	}
	.perfectwrap .selectwrap{
		padding-top:0.4rem;
		margin-top: 0;
	}
	.perfectwrap .submit1 {
	    height: 1.04rem;
	    line-height: 1.04rem;
	    background-color: #ff3838;
	    text-align: center;
	    color: #fff;
	    margin: 0 0.266666rem;
	    font-size: 16px;
	    border-radius: 0.1rem;
	    margin-top: 0.533333rem;
	}
</style>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'perfect',
	data:function() {
		return {
			bodyIsShow:false,
			periods:{
				cityId:10,
				successBannerList:[],
				// 已换成真实数据
				improveInfoTextFlag:1,
				// 已换成真实数据
				improveInfoText:"",
				// 已换成真实数据
				improveInfoPicFlag:1,
				// 已换成真实数据
				improveInfoPic:"",
				successBannerCb:false,
				picUrl:""
			},
			abTestFlag:null,
			// 已换成真实数据
			isTicket:null,
			address:null,
			// 已换成真实数据;
			car:null,
			buyway:1,
			buyList:[],
			// 已换成真实数据
			instalments:1
			
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/perfectmsg.css"
		});
	},
	mounted:function(){
		var self = this;
		//替换行情的icon
		var linkList = document.getElementsByTagName("link");
		for(var i=0; i<linkList.length;i++){
			if(linkList[i].type == "image/x-icon"){
				linkList[i].href = pathWebCommonUtils + "/img/common/V.ico"
			}
		};
		
		document.title="报名成功";
		// var applyId = "${applyId}";
	 //    var periodsId = '${periodsId}';
	 //    var sk = '${sk}';
	 //    var leaseCity = '${leaseCity}';
	 //    var lastInstalments = '${lastInstalments}';
	    window.cityId = self.$route.query.cityId;
	    self.periods.cityId =  self.$route.query.cityId;
		getCommonJsIns.initDefaultJS(self.webReady);
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

	    ga('create', 'UA-28316522-1', 'auto');
	    ga('send', 'pageview');

	},
	methods:{
		webReady:function(){
			 // 备份this
			 var self = this;
			 this.bodyIsShow = true;
			 var str = (window.location.href).substr((window.location.href).indexOf("?"));
			 self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applySupplement + str,
				type:"get",
				data:{},
				success:function(data){
					getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/carfestival/perfectmsg.js",function(){});
					//数据保存
					 var result = data.response.result.periods;
					 var overall = data.response.result;
					
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.periods.successBannerCb = result.successBannerCb;
					 	for(var i in result.successBannerList){
					 		self.periods.successBannerList.push(result.successBannerList[i]);
					 	}
				        self.periods.improveInfoTextFlag = result.improveInfoTextFlag;
				        self.periods.improveInfoText = result.improveInfoText;
				        self.periods.improveInfoPicFlag = result.improveInfoPicFlag;
			            self.periods.improveInfoPic = result.improveInfoPic;
			            self.periods.picUrl =  result.picUrl;
			            if(overall.abTestFlag){
			            	self.abTestFlag = overall.abTestFlag;
			            	console.log(self.abTestFlag);
			            }

			            if(overall.address){
			            	self.address = overall.address;
			            	console.log(self.address);
			            }

			            if(overall.car){
			            	self.car = overall.car;
			            	console.log(self.car);
			            }

			            self.isTicket = overall.isTicket;

			            self.instalments = overall.instalments;
					 }
				},
				error:function(){}
			});
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
				type:"get",
				data:{
					cityId : self.$route.query.cityId
				},
				success:function(data){
					// 判断数据请求状态
					 if (data.responseHeader.status==200) {
					 	self.buyList = data.response.result;
					 }
				},
				error:function(){}
			});
		},
		submit:function(){
			var self = this;
			$("#submitBtn").attr("disabled","disabled");
			if($("#insertCarper").size()>0&&($("#insertCarper").data("brandId")==''|| $("#insertCarper").data("carstyleId")=='')) {
				Toast({
                  message: "请选择品牌或车型",
                  position: 'middle',
                  duration: 2000
                });
			}else if($("#address").val() =="") {
				Toast({
                  message: "请输入门票地址",
                  position: 'middle',
                  duration: 2000
                });
			} else {
				var sinData = {};
				if(self.$route.query.sk){
					sinData["sk"] = self.$route.query.sk
				};
				sinData['applyId'] = this.$route.query.applyId;
				sinData['groupbyNum'] = this.$route.query.periodsId;
				sinData['buyType'] = $("#index-cartype").find('.active').attr("data-buytype");
				sinData['splitMoney'] = $("#index-bystages").find('.active').attr("data-splitmoney");
				if($("#insertCarper").size()>0) {
					sinData['brandId'] = $("#insertCarper").data("brandId");
					sinData['carStyleId'] = $("#insertCarper").data("carstyleId");
					sinData['noCheckBrandStyle'] = 0;

				} else {
					sinData['noCheckBrandStyle'] = 1;
				}
				var addressId = $("#address").val();
				if(addressId) {
					sinData['paperTicketAddress'] = $("#address").val();
				}
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.supplementForM,
					type:"post",
					data:sinData,
					success:function(data){
						$("#submitBtn").removeAttr("disabled");
						if(data.responseHeader.status == 200){
//							window.location.href = context + "/hmtcj/suc?applyId=" + self.$route.query.applyId + "&periodsId=" + self.$route.query.periodsId + "&t=" + Date.parse(new Date());
							Toast({
				              message: "恭喜您领票成功",
				              position: 'middle',
				              duration: 2000
				            });
						}else{
							alert("请求失败")
						}
					},
					error:function(){
						$("#submitBtn").removeAttr("disabled");
						Toast({
		                  message: "系统忙，请稍后",
		                  position: 'middle',
		                  duration: 2000
		                });
					}
				});
			}
		},
			
		getData:function(event){
          webCommonUtil.getBrandCarStyle.init({
              domObj:event.target,
              callback:function(){
                //console.log($("#aa").data("carstyleiName"));
              },
              ajaxBrandParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.tcBrand,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:self.cityId
                }
              },
              ajaxCarStyleParams:{
                url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.baseDataTcStyle,
                type:"post",
                dataType:"json",
                async:false,
                data:{
                  cityId:self.cityId
                }
              }
            });
     },

		
	}
}
</script>


// WEBPACK FOOTER //
// src/views/toutiaoQuotation/quotationperfect.vue